module.exports = __webpack_public_path__ + "img/mannul_news_add-2.46df3e42.png";